export const PERSISTED_AT_SET_VALUE = 'financialEducation/setValue/persistedAt';

export const setPersistedAtValue = () => ({ type: PERSISTED_AT_SET_VALUE });
